import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
};

export type Assignment = {
  activeStatusUpdated: Scalars['Boolean'];
  assignedStatus?: Maybe<AssignmentAssignedStatus>;
  candidatedStatus?: Maybe<AssignmentCandidatedStatus>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  reputation?: Maybe<Reputation>;
  reputationToOffer?: Maybe<Reputation>;
  rewardAmount: Scalars['Int'];
  status: AssignmentState;
  type: AssignmentTypeType;
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
};

export type AssignmentAssignedStatus =
  | 'INSPECTION_MODIFICATION_REQUESTED'
  | 'IN_INSPECTION'
  | 'MODIFICATION_REQUESTED'
  | 'MODIFICATION_REQUESTED_RESPONDED'
  | 'SUBMITTED'
  | 'SUBMITTING';

export type AssignmentCandidatedStatus =
  | 'APPLIED'
  | 'APPLYING'
  | 'INSPECTION_MODIFICATION_REQUESTED'
  | 'IN_INSPECTION';

export type AssignmentState =
  | 'ASSIGNED'
  | 'CANCELED'
  | 'CANDIDATED'
  | 'COMPLETED'
  | 'DECLINED';

export type AssignmentTypeType =
  | 'APPLIED'
  | 'COMPETITION'
  | 'DIRECTED';

/** Autogenerated input type of CompleteAssignment */
export type CompleteAssignmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of CompleteAssignment */
export type CompleteAssignmentPayload = {
  assignment?: Maybe<Assignment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export type Currency =
  | 'JPY'
  | 'USD';

export type MatchingFormat =
  | 'auto'
  | 'competition';

export type Mutation = {
  completeAssignment?: Maybe<CompleteAssignmentPayload>;
};


export type MutationCompleteAssignmentArgs = {
  input: CompleteAssignmentInput;
};

export type Offer = {
  assignmentStatus: OfferAssignmentStatus;
  assignments: Array<Assignment>;
  availableFrom?: Maybe<Scalars['ISO8601DateTime']>;
  availableTo?: Maybe<Scalars['ISO8601DateTime']>;
  canCreativeVisibilityOnProfile: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  expectedDue: Scalars['ISO8601DateTime'];
  expressDelivery: Scalars['Boolean'];
  id: Scalars['ID'];
  jobId: Scalars['String'];
  matchingFormat: MatchingFormat;
  name: Scalars['String'];
  organization: Organization;
  rewardAmount: Scalars['Int'];
  rewardCurrency?: Maybe<Currency>;
  rewardQuota: Scalars['Int'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type OfferAssignmentStatus =
  | 'ASSIGNED'
  | 'ASSIGNING'
  | 'COMPLETED';

export type Operation = {
  available: Scalars['Boolean'];
  reason?: Maybe<OperationNotAvailableReason>;
};

export type OperationNotAvailableReason =
  | 'NOT_AVAILABLE'
  | 'PERMISSION_DENIED';

export type Organization = {
  id: Scalars['ID'];
  name: Scalars['String'];
  profileImageUrl: Scalars['String'];
};

export type Query = {
  assignment: Assignment;
  offer: Offer;
};


export type QueryAssignmentArgs = {
  id: Scalars['ID'];
};


export type QueryOfferArgs = {
  id: Scalars['ID'];
};

export type Reputation = {
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  evaluator: User;
  id: Scalars['ID'];
  operations: ReputationOperations;
  score: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ReputationOperations = {
  update: Operation;
};

export type User = {
  id: Scalars['ID'];
  name: Scalars['String'];
  profileImageUrl: Scalars['String'];
};

export type SingleReputationFragment = { id: string, comment?: string | null, score: number, updatedAt: any, evaluator: { id: string, name: string, profileImageUrl: string } };

export type SingleAssignmentFragment = { id: string, status: AssignmentState, assignedStatus?: AssignmentAssignedStatus | null, candidatedStatus?: AssignmentCandidatedStatus | null, user: { id: string, name: string, profileImageUrl: string }, reputation?: { id: string, comment?: string | null, score: number, updatedAt: any, evaluator: { id: string, name: string, profileImageUrl: string } } | null, reputationToOffer?: { id: string, comment?: string | null, score: number, updatedAt: any, evaluator: { id: string, name: string, profileImageUrl: string } } | null };

export type AssignmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AssignmentQuery = { assignment: { id: string, status: AssignmentState, assignedStatus?: AssignmentAssignedStatus | null, candidatedStatus?: AssignmentCandidatedStatus | null, user: { id: string, name: string, profileImageUrl: string }, reputation?: { id: string, comment?: string | null, score: number, updatedAt: any, evaluator: { id: string, name: string, profileImageUrl: string } } | null, reputationToOffer?: { id: string, comment?: string | null, score: number, updatedAt: any, evaluator: { id: string, name: string, profileImageUrl: string } } | null } };

export type CompleteAssignmentMutationVariables = Exact<{
  assignmentId: Scalars['ID'];
}>;


export type CompleteAssignmentMutation = { completeAssignment?: { assignment?: { id: string, status: AssignmentState, assignedStatus?: AssignmentAssignedStatus | null, candidatedStatus?: AssignmentCandidatedStatus | null, user: { id: string, name: string, profileImageUrl: string }, reputation?: { id: string, comment?: string | null, score: number, updatedAt: any, evaluator: { id: string, name: string, profileImageUrl: string } } | null, reputationToOffer?: { id: string, comment?: string | null, score: number, updatedAt: any, evaluator: { id: string, name: string, profileImageUrl: string } } | null } | null } | null };

export type SingleOfferFragment = { id: string, assignmentStatus: OfferAssignmentStatus, rewardQuota: number, assignments: Array<{ id: string, status: AssignmentState, assignedStatus?: AssignmentAssignedStatus | null, candidatedStatus?: AssignmentCandidatedStatus | null, user: { id: string, name: string, profileImageUrl: string }, reputation?: { id: string, comment?: string | null, score: number, updatedAt: any, evaluator: { id: string, name: string, profileImageUrl: string } } | null, reputationToOffer?: { id: string, comment?: string | null, score: number, updatedAt: any, evaluator: { id: string, name: string, profileImageUrl: string } } | null }> };

export type OfferQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OfferQuery = { offer: { id: string, assignmentStatus: OfferAssignmentStatus, rewardQuota: number, assignments: Array<{ id: string, status: AssignmentState, assignedStatus?: AssignmentAssignedStatus | null, candidatedStatus?: AssignmentCandidatedStatus | null, user: { id: string, name: string, profileImageUrl: string }, reputation?: { id: string, comment?: string | null, score: number, updatedAt: any, evaluator: { id: string, name: string, profileImageUrl: string } } | null, reputationToOffer?: { id: string, comment?: string | null, score: number, updatedAt: any, evaluator: { id: string, name: string, profileImageUrl: string } } | null }> } };

export const SingleReputationFragmentDoc = gql`
    fragment SingleReputation on Reputation {
  id
  comment
  evaluator {
    id
    name
    profileImageUrl
  }
  score
  updatedAt
}
    `;
export const SingleAssignmentFragmentDoc = gql`
    fragment SingleAssignment on Assignment {
  id
  status
  assignedStatus
  candidatedStatus
  user {
    id
    name
    profileImageUrl
  }
  reputation {
    ...SingleReputation
  }
  reputationToOffer {
    ...SingleReputation
  }
}
    ${SingleReputationFragmentDoc}`;
export const SingleOfferFragmentDoc = gql`
    fragment SingleOffer on Offer {
  id
  assignmentStatus
  rewardQuota
  assignments {
    ...SingleAssignment
  }
}
    ${SingleAssignmentFragmentDoc}`;
export const AssignmentDocument = gql`
    query assignment($id: ID!) {
  assignment(id: $id) {
    ...SingleAssignment
  }
}
    ${SingleAssignmentFragmentDoc}`;

/**
 * __useAssignmentQuery__
 *
 * To run a query within a React component, call `useAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssignmentQuery(baseOptions: Apollo.QueryHookOptions<AssignmentQuery, AssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignmentQuery, AssignmentQueryVariables>(AssignmentDocument, options);
      }
export function useAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignmentQuery, AssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignmentQuery, AssignmentQueryVariables>(AssignmentDocument, options);
        }
export type AssignmentQueryHookResult = ReturnType<typeof useAssignmentQuery>;
export type AssignmentLazyQueryHookResult = ReturnType<typeof useAssignmentLazyQuery>;
export type AssignmentQueryResult = Apollo.QueryResult<AssignmentQuery, AssignmentQueryVariables>;
export const CompleteAssignmentDocument = gql`
    mutation completeAssignment($assignmentId: ID!) {
  completeAssignment(input: {id: $assignmentId}) {
    assignment {
      ...SingleAssignment
    }
  }
}
    ${SingleAssignmentFragmentDoc}`;
export type CompleteAssignmentMutationFn = Apollo.MutationFunction<CompleteAssignmentMutation, CompleteAssignmentMutationVariables>;

/**
 * __useCompleteAssignmentMutation__
 *
 * To run a mutation, you first call `useCompleteAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAssignmentMutation, { data, loading, error }] = useCompleteAssignmentMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useCompleteAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAssignmentMutation, CompleteAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAssignmentMutation, CompleteAssignmentMutationVariables>(CompleteAssignmentDocument, options);
      }
export type CompleteAssignmentMutationHookResult = ReturnType<typeof useCompleteAssignmentMutation>;
export type CompleteAssignmentMutationResult = Apollo.MutationResult<CompleteAssignmentMutation>;
export type CompleteAssignmentMutationOptions = Apollo.BaseMutationOptions<CompleteAssignmentMutation, CompleteAssignmentMutationVariables>;
export const OfferDocument = gql`
    query offer($id: ID!) {
  offer(id: $id) {
    ...SingleOffer
  }
}
    ${SingleOfferFragmentDoc}`;

/**
 * __useOfferQuery__
 *
 * To run a query within a React component, call `useOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOfferQuery(baseOptions: Apollo.QueryHookOptions<OfferQuery, OfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferQuery, OfferQueryVariables>(OfferDocument, options);
      }
export function useOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferQuery, OfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferQuery, OfferQueryVariables>(OfferDocument, options);
        }
export type OfferQueryHookResult = ReturnType<typeof useOfferQuery>;
export type OfferLazyQueryHookResult = ReturnType<typeof useOfferLazyQuery>;
export type OfferQueryResult = Apollo.QueryResult<OfferQuery, OfferQueryVariables>;